<template>
  <li class="collab-type-snippet">
    <div class="collab-type-snippet__slot">
      <slot />
    </div>
    <img class="collab-type-snippet__icon" :src="`/images/${props.icon}.svg`" :alt="props.title" />

    <div class="collab-type-snippet__title-and-button">
      <div class="collab-type-snippet__title-and-subtitle">
        <div class="global-h2 collab-type-snippet__title">
          {{ props.title }}
        </div>

        <div v-if="props.subTitle" class="collab-type-snippet__subtitle">
          {{ props.subTitle }}
        </div>
      </div>

      <div class="collab-type-snippet__cta-button-wrap">
        <SrpButton
          class="collab-type-snippet__cta-button"
          fill="outlined"
          :size="screenSize === 'mobile' ? 'small' : 'normal'"
          :style="{
            minWidth: props.ctaButtonMinWidth === 'unset' ? 'unset' : props.ctaButtonMinWidth + 'px',
          }"
        >
          {{ props.ctaButtonText }}
          <template v-if="props.ctaButtonIcon !== 'empty'" #iconRight>
            <IconEmbedded :name="props.ctaButtonIcon" :size="18" />
          </template>
        </SrpButton>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { Ref, inject } from "vue";

// Components
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// Types
import { ScreenSize } from "@contracts/screenSize";

const props = withDefaults(
  defineProps<{
    icon?: string;
    title?: string;
    subTitle?: string;
    ctaButtonText?: string;
    ctaButtonIcon?: string | "empty";
    ctaButtonMinWidth?: number | "unset";
  }>(),
  {
    icon: "CTA button",
    title: "Collab type",
    subTitle: "",
    ctaButtonText: "CTA button",
    ctaButtonIcon: "arrow-right_3",
    ctaButtonMinWidth: 165,
  }
);

// Global variables & injections
const screenSize = inject("screenSize") as Ref<ScreenSize>;
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Collab type snippet ========================================================
.collab-type-snippet {
  min-height: 85px;
  padding: 0 20px;
  border: 1px rgba(0, 0, 0, 0.2) solid;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &:hover {
    border-color: rgba(240, 240, 240, 1);
    background: rgba(240, 240, 240, 1);
  }

  &__icon {
    width: 67px;
    height: 67px;
    margin-right: 20px;
  }

  &__title-and-button {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  &__title-and-subtitle {
    flex-grow: 1;
  }

  &__title {
    flex-grow: 1;
    font-weight: 500;
  }

  &__subtitle {
  }

  &:hover &__title {
    text-decoration: underline;
    text-decoration-color: rgba(0, 0, 0, 0.2);
    text-underline-offset: 3px;
    text-decoration-thickness: 1px;
  }

  &__cta-button-wrap {
    padding-left: 25px;
    position: relative;

    &::before {
      content: "";
      width: 0;
      height: calc(100% + 12px);
      border-left: 1px rgba(0, 0, 0, 0.1) solid;
      position: absolute;
      inset: -6px auto auto 0;
    }
  }

  &__cta-button {
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .collab-type-snippet {
    &__icon {
      margin-top: 10px;
      align-self: flex-start;
    }

    &__title-and-button {
      padding: 12px 0 17px;
      flex-direction: column;
      align-items: flex-start;
    }

    &__title-and-subtitle {
      margin-bottom: 11px;
    }

    &__cta-button-wrap {
      padding-left: 0;

      &::before {
        display: none;
      }
    }

    &__cta-button {
      min-width: unset !important;
    }
  }
}
</style>
